<!--<a *ngIf="token" target="_blank" href="/api/tracking/show-document/get-show-data/{{token}}">Show</a>-->
<button class="btn btn-link" (click)="showFile()">View <ep-svg-icon icon="eye"></ep-svg-icon></button>
